import { TextField, Tooltip, Box, Chip } from "@mui/material";
import React from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import DescriptionSeeMore from "./DescriptionSeeMore";

const SomeThingElseExercisesUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  mainindex,
  message,
}) => {
  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[index][name] = value;

    setaddArray(list);
    setModalChangeExe(true);
  };

  return (
    <div className="my-2">
      <div className="characters mt-2">
        <div
          style={{
            width: "100%",
            padding: "1px",
            position: "relative",
          }}
        >
          <div
            className="d-flex my-1 workout-set-card w-100"
            style={{
              width: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
              }}
            >
              <div className="d-flex align-items-start justify-content-between w-100 ">
                <div className="w-100 d-flex align-items-center">
                  {addArray[mainindex].is_modified && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-11px",
                        justifyContent: "center",
                        zIndex: "1",
                        left: "-38px",
                        transform: "rotate(-53deg)",
                      }}
                    >
                      <Chip
                        label={"Modified"}
                        variant="contained"
                        color={"error"}
                        sx={{
                          fontSize: "10px",
                          height: "auto",
                          width: "auto",
                        }}
                      />
                    </span>
                  )}
                  <Tooltip placement="top" title={message}>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      placeholder="Name"
                      value={
                        addArray[mainindex].title
                          ? addArray[mainindex].title
                          : ""
                      }
                      name="title"
                      onChange={(e) => handleChangeDes(e, mainindex)}
                      InputLabelProps={{
                        className: "textfiels-input-label",
                        shrink: true,
                        style: { fontSize: "14px" },
                      }}
                      label="Name"
                      InputProps={{
                        className: "textfiels-input-value",
                        style: {
                          fontSize: "13px",
                          paddingLeft: "6px",
                        },
                        inputProps: {
                          readOnly: true,
                        },
                      }}
                      sx={{
                        borderRadius: "5px",
                        fontSize: "13px",
                        width: "50%",
                      }}
                    />
                  </Tooltip>
                </div>
                <div className=" cross-icon d-flex justify-content-end ">
                  {addArray.length > 1 ? (
                    <>
                      <Tooltip placement="top" title={message}>
                        <RemoveCircleOutlineIcon className="diary-icon-remove" />
                      </Tooltip>
                    </>
                  ) : (
                    ""
                  )}
                  <Tooltip placement="top" title={message}>
                    <AddCircleOutlineIcon className="diary-icon-add" />
                  </Tooltip>
                  <Tooltip placement="top" title={message}>
                    <span>
                      <CustomPopoverSection menu={[]} data={mainindex} />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <Tooltip placement="top" title={message}>
                {addArray[mainindex].description && (
                  <DescriptionSeeMore
                    description={addArray[mainindex].description}
                  />
                )}
              </Tooltip>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SomeThingElseExercisesUI;
